import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const PrimeNgCustomPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#ececec', // це клік на сорт
      100: '#bbdefb',
      200: '#90caf9',
      300: '#64b5f6',
      400: '#42a5f5',
      500: '#ececec', // основний оранжевий
      600: '#ececec', // ховер на кнопках
      700: '#1976d2',
      800: '#1565c0',
      900: '#0d47a1',
    },
    surface: {
      50: '#ffffff',
      100: '#f8f9fa',
    },
    neutral: {
      300: '#dee2e6',
      500: '#6c757d',
      700: '#343a40',
    },
  },
} as Parameters<typeof definePreset>[1]);

export default PrimeNgCustomPreset;
